import React from 'react'
import './Loader.css'

export default ({
  className = ''
}) => (
  <div className={`loader ${className}`}><div className="ball-clip-rotate"><div></div></div></div>
)
